import React from 'react'

import { Grid } from '../structure/Grid'

const Center = ({ children, ...props }) => (
  <Grid align="center" justify="center" {...props}>
    {children}
  </Grid>
)

export default Center
